module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5VRbu"))).then(() => parcelRequire('iDabs'));